module.exports = __webpack_public_path__ + "assets/5e6ed6a6b32bbcfdd4d9f0ccbc35a46a.png";